import React from "react";
import "../styles/nool.css";

const Noolagapani = () => {
  return (
    <div className="container">
      <div className="header">
        <h1 className="title">மக்கள் சிந்தனைப் பேரவை சார்பில் குக்கிராமத்தில் புதிய நூலகம்</h1>
      </div>
      <div className="content">
        <p className="paragraph">
          <span className="specialText">மக்கள் சிந்தனைப் பேரவையின் சார்பில்</span> ஈரோடு மாவட்டம் சிவகிரி அருகிலுள்ள
          எல்லப்பாளையம் என்ற கிராமத்தில் புதிய நூலகம் திறக்கப்பட்டது. நூலகத்
          திறப்பு விழா 29.2.2010 ஆம் தேதி ஞாயிற்றுக்கிழமை மாலை 6.00 மணிக்கு
          நடைபெற்றது. சிவகிரி அரசு மேல்நிலைப்பள்ளியின் தலைமை ஆசிரியர் திரு சி.
          ஆறுமுகம் அவர்கள் தலைமை ஏற்றார். அரசுப்பள்ளி ஆசிரியர் எம். பால்ராஜ்
          வரவேற்றார். மக்கள் சிந்தனைப் பேரவையின் தலைவர் த.ஸ்டாலின் குணசேகரன்
          நூலகத்தைத் திறந்து வைத்து விழாச் சிறப்புரையாற்றினார்.
        </p>
        <p className="paragraph">
          இந்நூலகத்தை <span className="specialText">மக்கள் சிந்தனைப் பேரவை வாசகர் வட்டம்</span> என்ற பெயரில் அவ்வூரிலுள்ள
          விவசாயிகள் மற்றும் பொதுமக்கள் தங்களுக்குள் வசூல் செய்து 1,000 க்கும்
          மேற்பட்ட நூல்களை வாங்கி வைத்துள்ளனர். இந்த நல்ல முயற்சிக்கு
          ஒத்துழைக்கும் வகையில் ஒரு விவசாயி தனது வீட்டை வாடகையில்லாமல் நூலகப்
          பயன்பாட்டிற்கு வழங்கியுள்ளார்.
        </p>
        <p className="paragraph">
          ஊரே திரண்டு நின்று இத்திறப்பு விழாவை
          மகிழ்ச்சியுடன் தனது குடும்ப விழா போல் ஏற்பாடு செய்திருந்த விதம் ஒரு
          நம்பிக்கை ஒளியை அனைவரது உள்ளத்திலும் பாய்ச்சியது.
        </p>
      </div>
    </div>
  );
};

export default Noolagapani;